var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success"},[_c('h1',{staticClass:"title mb-5"},[_vm._v("Success!")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }